import { WorkflowStepDefinition } from 'src/app/models/server/workflow-step-definition';

/**
 * Représente un événement clic sur un élément du menu contextuel d'une étape de workflow
 */
export class WorkflowContextMenuItemEvent {
    /**
     * Constructeur.
     * @param menuItemId : Identifiant de l'élément du menu selectionné.
     * @param menuItemData : Données attachées à l'élément du menu selectionné.
     */
    constructor(
        public menuItemId: string,
        public menuItemData: WorkflowStepDefinition
    ) {}
}
